export const DOCUMENT_TYPE_LABELS = {
  idf: 'Invention Disclosure Form',
  transcript: 'Transcript',
  reference: 'Reference',
  application: 'Application',
  figures: 'Figures',
  reports: 'Reports',
  officeaction: 'Office Action',
  officeactionresponse: 'Office Action Response',
  email: 'Email',
  other: 'Other'
};

export function normalizeDocumentTypeKey(key) {
  return String(key || '')
    .toLowerCase()
    .replace(/[\s_-]/g, '');
}

export function getDocumentTypeLabel(key, fallback) {
  const normalized = normalizeDocumentTypeKey(key);
  return DOCUMENT_TYPE_LABELS[normalized] || fallback || key;
}

export const DEFAULT_PREFERRED_DATA_TYPE = 'TextAndImage';
export const FIGURES_PREFERRED_DATA_TYPE = 'Image';

export function isFiguresDocumentType(type) {
  return normalizeDocumentTypeKey(type) === 'figures';
}

export function preferredDataTypeForDocumentType(type, userPreferredDataType) {
  if (isFiguresDocumentType(type)) {
    return FIGURES_PREFERRED_DATA_TYPE;
  }
  return userPreferredDataType || DEFAULT_PREFERRED_DATA_TYPE;
}

const documentTypes = [
  {
    name: 'figures',
    color: 'rgba(214, 232, 213, 0.5)'
  },
  {
    name: 'reference',
    color: 'rgba(128,0,128,0.3)'
  },
  {
    name: 'transcript',
    color: 'rgba(0, 128, 255, 0.5)'
  },
  {
    name: 'reports',
    color: 'rgba(172, 134, 166, 0.5)'
  },
  {
    name: 'other',
    color: 'rgba(240, 240, 240, 0.5)'
  },
  {
    name: 'application',
    color: 'rgba(255, 230, 153, 0.5)'
  },
  {
    name: 'email',
    color: 'rgba(173, 216, 230, 0.5)'
  },
  {
    name: 'idf',
    color: 'rgba(204, 229, 204, 0.5)'
  },
  {
    name: 'office action',
    color: 'rgba(255, 200, 170, 0.5)'
  },
  {
    name: 'office action response',
    color: 'rgba(255, 180, 140, 0.5)'
  }
];

export default documentTypes;
export function getItemColor(type) {
  const normalized = normalizeDocumentTypeKey(type);
  const item = documentTypes.find(item => normalizeDocumentTypeKey(item.name) === normalized);
  if (!item) {
    return 'rgba(240, 240, 240, 0.5)';
  }
  return item.color;
}

export const documentsOrder = [
  'specification',
  'claims',
  'figures',
  'response',
  'reference',
  'form',
  'working-copy',
  'disclosure',
  'transcript',
  'reports',
  'other'
];
